var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPro12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.605,
    height: 69.604,
    viewBox: "0 0 58.605 69.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_10_55",
    "data-name": "Komponente 10 \\u2013 55",
    transform: "translate(0.1 0.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "salad",
    transform: "translate(-43.872 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35456",
    "data-name": "Gruppe 35456",
    transform: "translate(43.872 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46757",
    "data-name": "Pfad 46757",
    d: "M290.287,150.609a.864.864,0,1,0,1.222,1.222l.929-.929a.864.864,0,0,0-1.222-1.222Z",
    transform: "translate(-261.668 -132.208)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46758",
    "data-name": "Pfad 46758",
    d: "M277.017,123.423h1.313a.864.864,0,0,0,0-1.729h-1.313a.864.864,0,0,0,0,1.729Z",
    transform: "translate(-249.386 -107.671)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46759",
    "data-name": "Pfad 46759",
    d: "M108.007,13.821A9.446,9.446,0,0,0,121.331.5a1.442,1.442,0,0,0-2.108-.075L116.635,3.01a.864.864,0,0,0,1.222,1.222l2.365-2.365a7.718,7.718,0,0,1-10.846,10.846l5.6-5.6a.864.864,0,0,0-1.222-1.222l-5.822,5.822a1.442,1.442,0,0,0,.075,2.108Z",
    transform: "translate(-100.177 0)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46760",
    "data-name": "Pfad 46760",
    d: "M182.658,76.586a.864.864,0,0,0,0,1.222l.828.828a.864.864,0,0,0,1.222-1.222l-.828-.828A.864.864,0,0,0,182.658,76.586Z",
    transform: "translate(-166.441 -67.537)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46761",
    "data-name": "Pfad 46761",
    d: "M158.532,85.737a.864.864,0,0,0-.864.864v1.171a.864.864,0,0,0,1.729,0V86.6A.864.864,0,0,0,158.532,85.737Z",
    transform: "translate(-144.555 -75.857)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46762",
    "data-name": "Pfad 46762",
    d: "M194.111,53.92h1.171a.864.864,0,0,0,0-1.729h-1.171a.864.864,0,0,0,0,1.729Z",
    transform: "translate(-176.034 -46.177)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46763",
    "data-name": "Pfad 46763",
    d: "M89.863,93.392H88.112c-.033-.13-.07-.26-.115-.391,2.856-.663,4.763-2.395,4.763-4.441a4.179,4.179,0,0,0-2.349-3.5c2.583-2.811,2.931-6.764.731-8.963a4.776,4.776,0,0,0-1.456-.993,8.211,8.211,0,0,0-1.117-3.927.864.864,0,1,0-1.492.873,6.473,6.473,0,0,1,.851,2.618,6.387,6.387,0,0,0-1.24.022,5.251,5.251,0,0,0-9-3.007l-.872-.872a6.483,6.483,0,0,1,7.693-1.229.864.864,0,0,0,.809-1.527,8.21,8.21,0,0,0-9.724,1.534L71.6,65.6a1.436,1.436,0,0,0-1.063-.421,1.454,1.454,0,0,0-1.041.491,10.483,10.483,0,0,0-2.23,9.7,4.639,4.639,0,0,0-2.533,2.2,8.132,8.132,0,0,0-4.452-2.148,5.692,5.692,0,0,0-3.18.464,8.213,8.213,0,1,0-9.4,13.461,4.027,4.027,0,0,0-.431,1.332,4.172,4.172,0,0,0,.586,2.71H45.889a2.03,2.03,0,0,0-1.465.629,1.985,1.985,0,0,0-.549,1.481A24.045,24.045,0,0,0,58.71,116.479a2.558,2.558,0,0,0,.981.192H76.061a2.559,2.559,0,0,0,.981-.192A24.045,24.045,0,0,0,91.878,95.5a1.985,1.985,0,0,0-.549-1.481A2.03,2.03,0,0,0,89.863,93.392ZM81.471,71.8a3.532,3.532,0,0,1,3.52,3.3,8.436,8.436,0,0,0-2.465,1.429l-3.621-3.621A3.516,3.516,0,0,1,81.471,71.8Zm-.343,6.86a.864.864,0,0,0,1.48.236,7.417,7.417,0,0,1,.516-.576c2.149-2.148,5.2-2.6,6.8-1s1.152,4.647-1,6.8a7.4,7.4,0,0,1-.567.509.864.864,0,0,0,.237,1.479c1.5.572,2.438,1.513,2.438,2.455,0,1.363-1.887,2.621-4.389,2.926A.864.864,0,0,0,86,92.775a4.606,4.606,0,0,1,.3.617h-.335l-5.446-5.446,4.9-4.9A.864.864,0,0,0,84.2,81.819l-4.9,4.9-3.97-3.97a1.48,1.48,0,0,0-2.162.075A10.334,10.334,0,0,0,71.4,85.677a7.121,7.121,0,0,1-.45-2.488,2.632,2.632,0,0,1,.99-2.264,1.659,1.659,0,0,1,.839-.208,3.475,3.475,0,0,1,1.683.521.864.864,0,0,0,1.288-.644c.307-2.5,1.565-4.377,2.925-4.377.942,0,1.883.934,2.455,2.439Zm2.206,14.552q-.151.1-.309.183H79.054a4.2,4.2,0,0,1-1.533-6ZM66.146,88.926a5.265,5.265,0,0,0-5.2,4.466H59.705a6.489,6.489,0,0,1,12.882,0H71.343A5.265,5.265,0,0,0,66.146,88.926Zm3.438,4.466H62.708a3.528,3.528,0,0,1,6.876,0Zm2.79-4.564a8.647,8.647,0,0,1,1.92-4.66l1.987,1.987a5.94,5.94,0,0,0,.128,7.238H74.327A8.184,8.184,0,0,0,72.374,88.828ZM70.6,67.047,78.1,74.541c-1.787.322-3.26,2.125-3.861,4.7a4.76,4.76,0,0,0-1.049-.234,3.833,3.833,0,0,0-.793,0,5.321,5.321,0,0,0-3.333-3.677A8.762,8.762,0,0,1,70.6,67.047ZM56.987,78.056a3.616,3.616,0,0,1,3.085-.916,6.475,6.475,0,0,1,3.711,1.912,7.405,7.405,0,0,1,.516.575.864.864,0,0,0,1.48-.236c.572-1.5,1.513-2.439,2.455-2.439,1.027,0,1.995,1.073,2.54,2.673a4.286,4.286,0,0,0-1.555,3.534,9.256,9.256,0,0,0,.825,3.789,8.169,8.169,0,0,0-3.9-.985h-.029l-3.409-3.409a.864.864,0,0,0-1.222,1.222l2.482,2.482A8.253,8.253,0,0,0,58.3,91.744c-1.459-.558-2.42-1.476-2.42-2.449,0-.942.934-1.883,2.438-2.455a.864.864,0,0,0,.237-1.479,7.359,7.359,0,0,1-.567-.509,6.477,6.477,0,0,1-1.913-3.711A3.616,3.616,0,0,1,56.987,78.056Zm-6.761,7.338a3.525,3.525,0,1,1,4.139-5.7,5.878,5.878,0,0,0-.057.663,4.136,4.136,0,0,0-2.439.825A4.622,4.622,0,0,0,50.226,85.394Zm1.716,3.026a.864.864,0,0,0,.607-1.262c-.96-1.775-.807-3.71.365-4.6a2.49,2.49,0,0,1,1.57-.486A8.315,8.315,0,0,0,56.5,85.8a4.179,4.179,0,0,0-2.349,3.5c0,1.757,1.408,3.282,3.613,4.1h-7.7a2.835,2.835,0,0,1-1.076-2.476A3.3,3.3,0,0,1,51.943,88.419Zm-6.249-5.956a6.486,6.486,0,0,1,9.943-5.493,4.83,4.83,0,0,0-.718,1.007,5.255,5.255,0,1,0-4.926,9.263A5.482,5.482,0,0,0,48.8,88,6.492,6.492,0,0,1,45.694,82.463Zm44.02,16.348H81.568a.864.864,0,0,0,0,1.729h7.715a22.347,22.347,0,0,1-12.9,14.342.838.838,0,0,1-.322.061H59.691a.838.838,0,0,1-.322-.061,22.347,22.347,0,0,1-12.9-14.342H77.42a.864.864,0,1,0,0-1.729H46.038a22.3,22.3,0,0,1-.437-3.4.269.269,0,0,1,.076-.2.291.291,0,0,1,.212-.091H89.863a.291.291,0,0,1,.212.091.269.269,0,0,1,.076.2,22.3,22.3,0,0,1-.437,3.4Z",
    transform: "translate(-43.872 -57.671)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46764",
    "data-name": "Pfad 46764",
    d: "M316.826,8.556a1.468,1.468,0,0,0,.379-.05l5.672-1.52h0a1.444,1.444,0,0,0,1.056-1.579A6.277,6.277,0,0,0,318.541.013a1.445,1.445,0,0,0-1.579,1.056l-1.52,5.672a1.442,1.442,0,0,0,1.385,1.814Zm1.738-6.789a4.55,4.55,0,0,1,3.616,3.616l-4.94,1.324Z",
    transform: "translate(-284.103 0)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35465",
    "data-name": "Gruppe 35465",
    transform: "translate(-335.495 -2891.503)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_555",
    "data-name": "Ellipse 555",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(364 2931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    transform: "translate(367 2934)",
    fill: "#fff",
    stroke: "#2ecf96",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46717",
    "data-name": "Pfad 46717",
    d: "M23.5,6l-7.692,7.7L13.5,11.392",
    transform: "translate(360.5 2936.15)",
    fill: "none",
    stroke: "#2ecf96",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro12);
export default __webpack_public_path__ + "static/media/Pro12.32cd7b680c31e05da473ab5bc392712e.svg";
export { ForwardRef as ReactComponent };